<template>
    <gofix-card title="SOR" class="contractTree" v-bind:class="{'run-loading':loadings.group}">
        <template slot="gofixCard:right_header">
            <div class="d-flex justify-content-end align-items-center">
                <b-button class="mr-2" :disabled ="!$checkRole($accessModule.sor, 'delete')" @click="modals.delete.open = true" title="Delete" v-b-tooltip.hover>
                    <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                    </svg>
                </b-button>
                <b-button class="mr-2" :disabled ="!$checkRole($accessModule.sor, 'create')" @click="openModalCreateGroup" title="Create" v-b-tooltip.hover>
                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                    </svg>
                </b-button>
                <b-button :disabled ="!$checkRole($accessModule.sor, 'update')" @click="editGroup" title="Edit" v-b-tooltip.hover>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.708 5.63151C21.098 6.02151 21.098 6.65151 20.708 7.04151L18.878 8.87151L15.128 5.12151L16.958 3.29151C17.1449 3.10426 17.3985 2.99902 17.663 2.99902C17.9276 2.99902 18.1812 3.10426 18.368 3.29151L20.708 5.63151ZM2.99805 20.5015V17.4615C2.99805 17.3215 3.04805 17.2015 3.14805 17.1015L14.058 6.19151L17.808 9.94151L6.88805 20.8515C6.79805 20.9515 6.66805 21.0015 6.53805 21.0015H3.49805C3.21805 21.0015 2.99805 20.7815 2.99805 20.5015Z" fill="#999999"/>
                    </svg>
                </b-button>
                <b-dropdown :disabled ="!$checkRole($accessModule.sor, 'create')" class="btn" right v-b-tooltip.hover title="Setting">
                    <b-dropdown-item href="#" @click="openImportModal">Import</b-dropdown-item>
                </b-dropdown>
            </div>
        </template>
        <div class="contenAbsolute">
            <div class="tree-view-properties">
            <tree :data="Groups" @node:selected="selectGroup"  @node:collapsed="collapseNode" @node:expanded="expandNode" ref="treeViewGroup">
                <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
            </tree>
          </div>
        </div>

        <b-modal 
            id="modal-Remove"
            title="Remove SOR Group"
            :no-close-on-backdrop="true" 
            hide-footer
            hide-header 
            centered 
            v-model="modals.delete.open"
            ref="modal-Remove">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?<br/>
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="modals.delete.deleteItems"
                    name="checkbox-1"
                    class="mt-3">
                    Delete SOR items in group
                </b-form-checkbox>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button>
                <b-button class="custom-btn" @click="deleteGroup" :disabled="modals.delete.loading">
                    <b-spinner v-if="modals.delete.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal 
            id="modal-Create"
            :title="modals.create.data.id ? 'Edit SOR Group':'Create New SOR Group'"
            :no-close-on-backdrop="true"
            hide-footer 
            centered 
            v-model="modals.create.open">
            <div v-bind:class="{'run-loading':modals.create.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="6" v-if="terms && ClientContractID.sor_group_root_id !== modals.create.data.id">
                            <gofix-form-tree
                                label="Parent"
                                :multiple="false"
                                :options="groups"
                                :normalizer="normalizer"
                                :default-expand-level="2"
                                v-model="modals.create.data.parent_id"
                                placeholder="">
                            </gofix-form-tree>
                        </b-col>
                        <b-col :md="terms && ClientContractID.sor_group_root_id !== modals.create.data.id ? 6:12">
                            <gofix-form-input class="nolabelUppercase" label="Group name" v-model="modals.create.data.description_one"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="APPLY" @click="saveGroup" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </gofix-card>
</template>
<script>
import { mapGetters } from 'vuex';
import LiquorTree from 'liquor-tree';

export default {
    name: 'sor-group',
    components: {
        [LiquorTree.name]: LiquorTree,
    },
    props:{
        terms: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    data () {
        return {
            rootId: null,
            nodeSelected: null,
            groups: null,
            modals:{
                create: {
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        parent_id: null,
                        description_one: null
                    }
                },
                delete: {
                    open: false,
                    loading: false,
                    deleteItems: false
                },
            },
            loadings:{
                group: false
            },
        }
    },
    watch: {
        terms: function(val) {
            if(val && val.id) {
                this.reloadGroup();
            }
        },
        Groups: function (val) {
            if(val && val[0]) {
                this.rootId = val[0].data.id;
                this.$nextTick(() => {
                    let nodeRoot = this.$refs.treeViewGroup.find({
                        data: {
                            id: this.rootId
                        }
                    })
                    var sorExpand = localStorage.getItem('sorExpand');
                    if(sorExpand){
                        sorExpand = JSON.parse(sorExpand);
                        sorExpand.forEach(item => {
                            let nodeExpand = this.$refs.treeViewGroup.find({
                                data: {id: item}
                            });
                            nodeExpand[0].expand();
                        });
                        var sorSelected = localStorage.getItem('sorSelected');
                        if(sorSelected){
                            let nodeSelected = this.$refs.treeViewGroup.find({
                                data: {id: parseInt(sorSelected)}
                            });
                            nodeSelected[0].select();
                            this.nodeSelected = nodeSelected[0];
                            this.selectGroup(nodeSelected[0], 1);
                        }
                    }else{
                        nodeRoot[0].expand();
                        nodeRoot[0].select();
                        this.nodeSelected = nodeRoot[0];
                        this.selectGroup(nodeRoot[0], 1);
                    }
                })
                
            }

            this.$set(this.$refs.treeViewGroup, 'model', val);
            this.$refs.treeViewGroup.tree.setModel(val);
            let data = this.$refs.treeViewGroup.toJSON();
            this.groups = JSON.parse(JSON.stringify(data, this.convertGroupFromTree));
        },
    },
    computed: {
        ...mapGetters({
            Groups:           'v2SorController/Groups',
            ClientContractID: 'ContractController/ClientContractID'
        })
    },
    created(){
        if(this.terms && this.terms.id)
            this.reloadGroup();
    },
    methods:{
        openImportModal(){
            this.$emit('importItem');
        },
        convertGroupFromTree(key, value){
            switch (key) {
                case "children":
                    if (value.length > 0) {
                        return value;
                    } else {
                        return undefined;
                    }
                    break;
                default:
                    return value;
            }
        },
        /*-- Group event --------------------------------*/
        collapseNode(node){
            var sorGroup = localStorage.getItem('sorExpand');
            if(sorGroup){
                sorGroup = JSON.parse(sorGroup);
                var arrVal = this.removeItem(sorGroup,node.id);
                localStorage.setItem('sorExpand', JSON.stringify(arrVal));
            }
        },
        expandNode(node){
            var $arrExpand = [];
            var sorGroup = localStorage.getItem('sorExpand');
            if(sorGroup){
                sorGroup = JSON.parse(sorGroup);
                $arrExpand = sorGroup.slice();
                if(!sorGroup.includes(node.id)){
                    $arrExpand.push(node.id);
                }
                localStorage.setItem('sorExpand', JSON.stringify($arrExpand));
            }else{
                var nod = node.id;
                $arrExpand.push(nod);
                localStorage.setItem('sorExpand', JSON.stringify($arrExpand));
            }
        },
        removeItem(arr, value) {
            var i = 0;
            while (i < arr.length) {
                if (arr[i] === value) {
                arr.splice(i, 1);
                } else {
                    ++i;
                }
            }
            return arr;
        },
        selectGroup(node,val){
            if (val){}
            else{
                localStorage.setItem('sorSelected', node.id);
            }
            this.nodeSelected = node;
            this.modals.create.data.parent_id = node.id;
            this.$emit('nodeChange', node);
        },
        deleteGroup(){
            if(!this.nodeSelected) return;
            this.modals.delete.loading = true;
            this.$store.dispatch('v2SorController/deleteGroup', {
                id: this.nodeSelected.id ,
                sor_group_id: this.ClientContractID.sor_group_root_id,
                deleteItemsInGroup: this.modals.delete.deleteItems
            }).then(response => {
                this.modals.create.data = {
                    parent_id:null,
                    description_one:null
                };
                if(this.nodeSelected.id != this.ClientContractID.sor_group_root_id) {
                    this.nodeSelected.remove();
                    this.nodeSelected = null;
                } else {
                    this.nodeSelected.children = [];
                    this.nodeSelected.unselect();
                    this.nodeSelected = null;
                }
                this.modals.delete.open = false;
                this.modals.delete.loading = false;

                let nodeRoot = this.$refs.treeViewGroup.find({
                    data: {
                        id: this.rootId
                    }
                })
                nodeRoot[0].select();
                nodeRoot[0].expand();
                
                this.nodeSelected = nodeRoot[0];
                this.selectGroup(nodeRoot[0]);

                this.$alertNotification(this.$notificationV2('deleting', 'sor_group'));
            }, error => {
                this.modals.delete.loading = false;
                console.log(error);
            });
        },
        saveGroup(){
            if(this.modals.create.loading) return;
            this.modals.create.loading = true;
            let bug = false;
            this.modals.create.data.parent_id = this.modals.create.data.parent_id ? this.modals.create.data.parent_id : null

            if(!this.modals.create.data.description_one){
                bug = true;
            }
            if(bug) {
                return this.$alertNotification("Please enter parent group and description", "danger");
            }
            let method = 'createGroup';
            if(this.modals.create.data.id) {
                method = 'updateGroup';
            }
            this.$store.dispatch( 'v2SorController/' + method, this.modals.create.data).then(async response => {
                if(method === "createGroup"){
                    this.$alertNotification(this.$notificationV2('adding', 'sor_group'));
                    let NodeFill = this.$refs.treeViewGroup.find({
                        data:{id:this.modals.create.data.parent_id}
                    },false);
                    let Node = NodeFill[0];
                    let activeNode = Node.append({
                        description_one: response.description_one,
                        text: response.description_one,
                        id:response.id,
                        data:{
                            id:response.id,
                            description_one: response.description_one,
                            parent_id: response.parent_id,
                            text: response.description_one,
                        }
                    });
                    if(this.nodeSelected != null && this.nodeSelected.data.id != Node.data.id) {
                        this.nodeSelected.unselect()
                        this.nodeSelected = null
                    }
                    Node.select(true);
                    Node.expand();
                } else {
                    this.$alertNotification(this.$notificationV2('editing', 'sor_group'));
                    this.nodeSelected.data.description_one = this.nodeSelected.data.text = response.description_one;
                    if(this.nodeSelected.data.parent_id !== response.parent_id) {
                        //Move group
                        this.$refs.treeViewGroup.remove(this.nodeSelected);
                        let NodeFill = this.$refs.treeViewGroup.find({
                            data:{id:response.parent_id}
                        },false);
                        let Node = NodeFill[0];
                        let activeNode = Node.append({
                            description_one: response.description_one,
                            text: response.description_one,
                            id:response.id,
                            data:{
                                id:response.id,
                                description_one: response.description_one,
                                parent_id: response.parent_id,
                                text: response.description_one,
                            }
                        });
                        activeNode.select(true);
                        Node.expand();
                    }
                }
                this.modals.create.data = {
                    id: null,
                    parent_id: null,
                    description_one: null
                };
                let data = this.$refs.treeViewGroup.toJSON();
                this.groups = JSON.parse(JSON.stringify(data, this.convertGroupFromTree));
                this.modals.create.open = false;
                this.modals.create.loading = false;
            }, error => {
                this.modals.create.loading = false;
                this.$alertNotification("Got nothing from server. Prompt user to check internet connection and try again", "danger");
            });
        },
        editGroup(){
            if(!this.nodeSelected) 
                return this.$alertNotification("Please select a group to edit", "danger");

            this.filterData(this.groups,this.nodeSelected.id);
            this.modals.create.data.parent_id = this.nodeSelected.data.parent_id;
            this.modals.create.data.description_one = this.nodeSelected.data.text;
            this.modals.create.data.id = this.nodeSelected.id;
            this.modals.create.open = true;
        },
        openModalCreateGroup() {
            this.modals.create.data = {
                id: null,
                parent_id: this.nodeSelected ? this.nodeSelected.id : null,
                description_one:null
            };
            this.filterData(this.groups,0);
            this.modals.create.open = true;
        },
        filterData(data, id) {
            data.filter((o) => {
                if (o.children) this.filterData(o.children, id);
                if(o.data.id === id){
                    o.isDisabled = true;
                }else{
                    o.isDisabled = false;
                }
            })
        },
        reloadGroup(){
            this.loadings.group = true;
            this.$store.dispatch( 'v2SorController/getGroup', this.ClientContractID.sor_group_root_id)
            .then(response => {
                this.loadings.group = false;
            }).catch(err => {
                this.loadings.group = false;
            });
        },
        /*-- Load data--------------------------------*/
        normalizer(node) {
            return {
                label: node.text,
                id: node.data.id,
            }
        },
    }
}
</script>
